import isNumber from './is-number';
/**
 * 判断值是否为偶数
 * @return 是否为偶数
 */
export default function isEven(num) {
    return isNumber(num) && num % 2 === 0;
}
//# sourceMappingURL=is-even.js.map